/**
 * Informs New Relic of an error. Returns a random error ID if NR is available, otherwise returns null.
 * @param {unknown} error
 * @returns {string | null}
 */
export const informNewRelic = (error) => {
  // @ts-expect-error - newrelic is not defined in the window object
  if (window.newrelic) {
    const errorId = new Date()
      .getTime()
      .toString()
      .split('')
      .map((s) => (Math.random() > 0.5 ? String.fromCharCode(97 + Number(s)) : s))
      .join('');
    // @ts-expect-error - newrelic is not defined in the window object
    window.newrelic.noticeError(error, {
      errorId,
    });
    return errorId;
  }
  return null;
};
